import type { MessageIOContext } from "./MessageIOContext.js";


export abstract class MessageOut {
    abstract write(
        context: MessageIOContext
    ): Record<string, any>;
}
